import RequestContextService from '../RequestContextService.js';
import getBaseUrl from '../getBaseUrl.js';
import { getInstance as getMSALInstance } from '../../msalSingleton.js';

export default async function redirectToLogin() {
  const baseUrl = getBaseUrl();

  return fetch(`${baseUrl}/authentication-logout`, {
    headers: {
      Accept: 'application/json',
      'Accept-encoding': 'gzip'
    },
    method: 'POST'
  }).finally(() => {
    getMSALInstance()?.clearCache();

    RequestContextService.clear();
    window.location.reload();
  });
}
